export function popup() {
  const popups = document.querySelectorAll(".popup");
  const _paq = window._paq || [];
  popups.forEach((dialog) => {
    const popups = document.querySelectorAll(".popup");
    const _paq = window._paq || [];
    popups.forEach((dialog) => {
      let delayInSeconds = parseInt(dialog.getAttribute("data-delay"));
      const currentPath = window.location.pathname.replace(/\/$/, ""); // remove trailing slash
      const currentSlug = currentPath.split("/").pop();

      // Handle includes/excludes logic
      const includesAttr = dialog.getAttribute("data-includes");
      const excludesAttr = dialog.getAttribute("data-excludes");

      if (includesAttr) {
        const includes = includesAttr.split(",").map((s) => s.trim());
        if (!includes.includes(currentSlug)) return;
      } else if (excludesAttr) {
        const excludes = excludesAttr.split(",").map((s) => s.trim());
        if (currentSlug !== "" && excludes.includes(currentSlug)) return;
      }

      // Check localstorage if popup was already show, if so, return
      const wasShown = sessionStorage.getItem(dialog.id + "_shown");
      if (wasShown) {
        delayInSeconds = 0;
      }

      // Check localstorage if popup is already closed, if so, return
      const isClosed = sessionStorage.getItem(dialog.id + "_closed");
      if (isClosed) return;

      // Check localstorage if popup is minimized
      const isMinimized = sessionStorage.getItem(dialog.id + "_minimized");
      if (isMinimized) {
        openDialog();
        minimizeDialog();
      }

      // Listen for click on close, and update localstorage
      const closeButton = dialog.querySelector(".popup__close-button");
      closeButton.addEventListener("click", () => {
        closeDialog();
      });

      // Listen for click on minimize, and update localstorage
      const minimizeButton = dialog.querySelector(".popup__minimize-button");
      minimizeButton.addEventListener("click", () => {
        minimizeDialog();
      });

      // Listen for mouseY movement to show popup if the mouse is travelling towards the top of the window
      const showOnIntent = parseInt(dialog.getAttribute("data-intent")) === 1;
      if (
        !wasShown &&
        showOnIntent &&
        window.matchMedia("(hover: hover)").matches
      ) {
        setTimeout(() => {
          let prevValue = null;
          function mouseListener(ev) {
            if (prevValue >= ev.clientY && ev.clientY < 5) {
              openDialog();
              removeEventListener("mousemove", mouseListener);
            }
            prevValue = ev.clientY;
          }
          addEventListener("mousemove", mouseListener);
        }, 3000);
      }

      if (wasShown && (!isClosed || !isMinimized)) {
        openDialog();
      }

      // Wait for the delay
      setTimeout(() => {
        if (
          isNaN(delayInSeconds) ||
          (showOnIntent && window.matchMedia("(hover: hover)").matches)
        )
          return;
        openDialog();
      }, delayInSeconds * 1000);

      // Helpers

      // Don't show the popup over an open modal or the open main menu
      function isBlockedByOverlay() {
        const modalIsOpen = document.querySelector(".modal-box.show");
        const menuIsOpen = document.querySelector(".nav--open");
        return Boolean(modalIsOpen || menuIsOpen);
      }
      function closeDialog() {
        dialog.close();
        sessionStorage.setItem(dialog.id + "_closed", true);
        _paq.push(["trackEvent", "Popup", "Close", window.location.pathname]);
        if (window.innerWidth < 768) {
          document.body.removeAttribute("style");
        }
      }

      function openDialog() {
        if (isBlockedByOverlay()) return;
        dialog.show();
        dialog.setAttribute("aria-hidden", false);
        sessionStorage.setItem(dialog.id + "_shown", true);

        _paq.push(["trackEvent", "Popup", "Open", window.location.pathname]);
        if (window.innerWidth < 768 && !dialog.hasAttribute("minimized")) {
          document.body.style.overflow = "hidden";
          document.body.style.touchAction = "none";
        }
      }
    });

    function minimizeDialog() {
      if (dialog.hasAttribute("minimized")) {
        dialog.removeAttribute("minimized");
        dialog.setAttribute("aria-expanded", true);
        sessionStorage.removeItem(dialog.id + "_minimized");
        _paq.push([
          "trackEvent",
          "Popup",
          "Maximize",
          window.location.pathname,
        ]);
        if (window.innerWidth < 768) {
          document.body.style.overflow = "hidden";
          document.body.style.touchAction = "none";
        }
      } else {
        dialog.setAttribute("minimized", "");
        dialog.setAttribute("aria-expanded", false);
        dialog.removeAttribute("aria-hidden");
        sessionStorage.setItem(dialog.id + "_minimized", true);
        _paq.push([
          "trackEvent",
          "Popup",
          "Minimize",
          window.location.pathname,
        ]);
        if (window.innerWidth < 768) {
          document.body.removeAttribute("style");
        }
      }
    }
  });
}
